<template>
    <v-navigation-drawer
      v-model="isOpenDrawer"
      @input="$emit('update:drawer', drawerState)"
      app
      fixed
      :left="$i18n.locale !== 'ar'"
      :right="$i18n.locale === 'ar'"
      temporary
    >
        <!-- username -->
        <v-list>
            <v-list-item>
                <v-list-item-avatar rounded="0">
                    <v-img contain src="@/assets/logo.png"/>
                </v-list-item-avatar>
                <v-list-item-title class="text-h6 font-weight-bold primary--text">
                    {{ userData.name }}
                </v-list-item-title>
            </v-list-item>
        </v-list>

        <v-divider/>

        <!-- links list -->
        <v-list
            nav
            dense
        >
            <v-list-item-group color="primary">
                <!-- Visits -->
                <v-list-item :to="{name: 'visits'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-medical-bag</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.visits')}}</v-list-item-title>
                </v-list-item>

                <!-- Visits frequency -->
                <v-list-item :to="{name: 'visits-frequency'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-chart-waterfall mdi-rotate-90</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.visits-frequency')}}</v-list-item-title>
                </v-list-item>

                <!-- Specialty visit materials -->
                <!-- <v-list-item -->
                    <!-- v-if="useMaterialsSpecialtyVisits"
                    :to="{name: 'specialty-visit-materials'}"
                    exact
                >
                    <v-list-item-icon>
                        <v-icon>mdi-medication</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.specialty-visit-materials')}}</v-list-item-title>
                </v-list-item> -->

                <!-- Plans -->
                <v-list-item v-if="usePlans" :to="{name: 'plans'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-notebook-edit-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.plans')}}</v-list-item-title>
                </v-list-item>

                <!-- Item Plan -->
                <v-list-item v-if="permissionItemPlan && permissionItemPlan !== rolePermission.undefined" :to="{name: isExcelItemPlan ? 'item-plan-excel' : 'item-plan' }" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-clipboard-list-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.item-plan')}}</v-list-item-title>
                </v-list-item>

                <!-- Customers -->
                <v-list-item :to="{name: 'customers'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-home-city-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.customers')}}</v-list-item-title>
                </v-list-item>

                <!-- Products -->
                <v-list-item :to="{name: 'products'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-palette-swatch</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.products')}}</v-list-item-title>
                </v-list-item>

                <!-- Materials Journal -->
                <v-list-item :to="{name: 'materials-journal'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-book-open-page-variant</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.materials-journal')}}</v-list-item-title>
                </v-list-item>

                <!-- Today Summary -->
                <v-list-item :to="{name: 'today-summary'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-calendar-today-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.today-summary')}}</v-list-item-title>
                </v-list-item>

                <!-- Expenses -->
                <v-list-item :to="{name: 'expenses'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-cash-multiple</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.expenses')}}</v-list-item-title>
                </v-list-item>

                <!-- Debt Visits -->
                <v-list-item v-if="permissionDebtSale && permissionDebtSale !== rolePermission.undefined" :to="{name: 'debt-visits'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-cash-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.debt-visits')}}</v-list-item-title>
                </v-list-item>

                <!-- Profile -->
                <v-list-item  :to="{name: 'profile'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.profile')}}</v-list-item-title>
                </v-list-item>

                <!-- Exams -->
                <v-list-item  :to="{name: 'exams'}" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-text-box-check-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('routes.exams')}}</v-list-item-title>
                </v-list-item>

                <!-- Logout -->
                <v-list-item @click="logout" exact>
                    <v-list-item-icon>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="text-subtitle-2">{{$T('components.logout')}}</v-list-item-title>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <!-- powered by -->
        <template v-slot:append>
            <div dir="ltr" class="text-overline ml-5 mb-3">
                v{{VERSION}} <br />
                powered by
				<a
					href="https://www.beetronix.com"
					target="_blank"
					class="beetronix text-uppercase text-decoration-none primary--text"
				>Beetronix</a>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
import { VERSION } from '@/helpers/constants'
import { mapState } from 'vuex'
import { useMaterialsSpecialtyVisits, usePlans, useMaterialsPlan } from '@/configs/general.configs'
import { rolePermission, permissionsNamesEnum } from '@/helpers/enums'
export default {
	model: {
		prop: 'drawer',
		event: 'update:drawer'
	},

	props: {
		drawer: { default: false }
	},

	data() {
		return {
			usePlans,
			useMaterialsSpecialtyVisits,
			useMaterialsPlan,
			drawerState: false,
			VERSION,
			rolePermission
		}
	},

	computed: {
		isOpenDrawer: {
			get() {
				return this.drawer;
			},

			set(newValue) {
				this.drawerState = newValue;
			}
		},

		...mapState({
			userData: state => state.auth.userData,
			permissionItemPlan: state => state.auth.userData.role?.permissions.find(c => c.permissionsNames === 23),
			permissionDebtSale: state => state.auth.userData.role?.permissions.find(c => c.permissionsNames === permissionsNamesEnum.DebtSale),
			isExcelItemPlan: state => state.configurations.systemConfigValue.properties?.find(c => c.key === 'isExcelItemPlan')?.value === undefined ? false : state.configurations.systemConfigValue.properties?.find(c => c.key === 'isExcelItemPlan')?.value
		})
	},

	methods: {
		logout() {
			this.$store.dispatch('auth/logout');
			this.$router.push({ name: 'login' });
		}
	},
}
</script>
